var map = {
	"./admin/menu": [
		931,
		8,
		3
	],
	"./aluno/menu": [
		934,
		4
	],
	"./colaborador/menu": [
		935,
		5
	],
	"./pesquisador/menu": [
		932,
		6
	],
	"./supervisor/menu": [
		933,
		7
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 674;
module.exports = webpackAsyncContext;